import TextField from "@material-ui/core/TextField";
import {LightTooltip} from "../../components/LightTooltip";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import IconButton from "@material-ui/core/IconButton";
import useStyles from "../muistyles";
import React, { useEffect } from "react";
import Paper from "@material-ui/core/Paper";
import "./table.css";
import Loading from "../Loading";


export function Table({
    search,//this is search function
    tableActions,// actions related to table
    columns, // array of strings table header
    rows, // formatted rows
    addscroll, // add scroll to the table
    tbcontainerstyle, // add style to the table
    tbscrollstyle,
    tbstyle,
    loading = false
}){
    const classes = useStyles();

    
    function getSearch(){
        if(search != null){
            return (
                
                <>
                {/* <div className="search"> */}
                <div style={{marginBottom:'20px'}}>
                <TextField
                    label="Search"
                    id="outlined-basic"
                    size="small"
                    className={classes.root}
                    variant="outlined"
                    onChange={(e) => search(e.target.value)}
                    InputProps={{
                    endAdornment: (
                        <InputAdornment>
                        <LightTooltip title="Search">
                        <IconButton>
                            <SearchIcon />
                        </IconButton>
                        </LightTooltip>
                        </InputAdornment>
                    ),
                    }}
                />
              {tableActions}
              </div>
              {/* </div> */}
              </>
            )
        }else{
            return ""
        }

    }


    return(
        <>
        <Loading loading={loading}/>
        <div className="amictbcontainer" style={tbcontainerstyle}>
                {getSearch()}
            

                
                <div className={ (addscroll === undefined || addscroll === true) ?"tableFixedHead":""} style={tbscrollstyle}>
                    <table className="amictb" style={tbstyle}>
                            <thead>
                        
                            {columns}
                            </thead>
                            <tbody>
                            {rows}
                            </tbody>
                        
                    </table>
                </div>
            </div>
            
          
      
    </>
    )


}